export default __webpack_public_path__ + "static/media/Aerosvit Aerosweet Airline logo.ee65632a.jpg";